import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyTaskDetailedReportDetails } from './Pages';

export const DailyTaskDetailedReportDetailsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyTaskDetailedReportDetails} />
    </Fragment>
)